import React from 'react'
import PropTypes from 'prop-types'

import ThemeTable from '@shared/components/themeTable'
import styles from './style.module.scss'
import dynamic from 'next/dynamic'
const FallWicketRow = dynamic(() => import('@shared/components/match/scorecardTable/FallWicketRow'))

const FallWickets = ({ data, is100 }) => {
  let fallOfWicketlabels
  if (is100) {
    fallOfWicketlabels = [`${'Fall of Wickets'}`, `${'Score'}`, `${'Balls'}`]
  } else {
    fallOfWicketlabels = [`${'Fall of Wickets'}`, `${'Score'}`, `${'Over'}`]
  }
  if (data?.aFOWs?.length) {
    return (
      <div className={`${styles?.personTbl} content-visibility-auto`}>
        <ThemeTable labels={fallOfWicketlabels} isBordered={true}>
          {data?.aFOWs?.map((fow, index) => {
            return <FallWicketRow key={index} fow={fow} />
          })}
        </ThemeTable>
      </div>
    )
  } else return null
}

FallWickets.propTypes = {
  data: PropTypes.object,
  styles: PropTypes.object,
  is100: PropTypes.bool
}

export default FallWickets
